import TabToggle from 'components/commons/tab-toogle'
import { InlineError, Input } from 'avo-ui'

export const ProductPageSetting = ({ sectionRef, productDetail, onChangeForm, errorForm }) => {
    return (
        <div ref={sectionRef?.product_page_setting}>
            <TabToggle
                title={'Product Page Setting'}
                content={
                    <div className={'grid grid-cols-2 gap-y-5 gap-x-16'}>
                        <div className={'flex flex-col space-y-3'}>
                            <div className={'font-semibold text-blue-90'}>Empty Product Label</div>
                            <Input
                                className={'flex-1'}
                                name={'out_of_stock_label'}
                                placeholder={'Masukkan label empty product'}
                                value={productDetail?.out_of_stock_label}
                                onChange={(item) => onChangeForm({ [item?.name]: item?.value })}
                            />
                            <InlineError className={'mt-2'} message={errorForm?.out_of_stock_label} />
                        </div>
                        <div className={'flex flex-col space-y-3'}>
                            <div className={'font-semibold text-blue-90'}>Limit Purchase</div>
                            <Input
                                type={'number'}
                                className={'flex-1'}
                                name={'limit_purchase'}
                                placeholder={'Masukkan label limit purchase'}
                                value={productDetail?.limit_purchase}
                                onChange={(item) => onChangeForm({ [item?.name]: item?.value })}
                            />
                            <InlineError className={'mt-2'} message={errorForm?.limit_purchase} />
                        </div>
                    </div>
                }
            />
        </div>
    )
}
